  document.addEventListener('DOMContentLoaded', function () {
    const faqItems = document.querySelectorAll('.faq-item');

    faqItems.forEach(item => {
      const button = item.querySelector('.faq-question');

      button.addEventListener('click', () => {
        const currentlyActive = document.querySelector('.faq-item.active');

        if (item === currentlyActive) {
          item.classList.remove('active');
          return;
        }

        if (currentlyActive) {
          currentlyActive.classList.remove('active');

          setTimeout(() => {
            item.classList.add('active');
          }, 400); 
        } else {
          item.classList.add('active');
        }
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const loadMoreBtn = document.getElementById('LoadMoreButton');
    if (!loadMoreBtn) return;

    loadMoreBtn.addEventListener('click', function () {
      const nextUrl = loadMoreBtn.getAttribute('data-next-url');
      const sectionId = loadMoreBtn.getAttribute('data-section-id');
      if (!nextUrl) return;

      loadMoreBtn.setAttribute('disabled', 'true');
      loadMoreBtn.textContent = 'Loading...';

      fetch(nextUrl + `?section_id=${sectionId}`)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newItems = doc.querySelectorAll('#product-grid .grid__item');
          const grid = document.querySelector('#product-grid');
          newItems.forEach(item => grid.appendChild(item));

          // Update next URL or remove button
          const newButton = doc.querySelector('#LoadMoreButton');
          if (newButton && newButton.dataset.nextUrl) {
            loadMoreBtn.setAttribute('data-next-url', newButton.dataset.nextUrl);
            loadMoreBtn.removeAttribute('disabled');
            loadMoreBtn.textContent = 'Load More';
          } else {
            loadMoreBtn.remove();
          }
        })
        .catch(error => {
          console.error('Load More error:', error);
          loadMoreBtn.textContent = 'Error!';
        });
    });
  });
